/* eslint-disable react/no-unescaped-entities */
import { Text } from "@engaging-tech/components"
import React from "react"

import { DesktopBoxWrapper, PlaceholderDiv } from "../styles"
import HappiestWorkplacesForYouButton from "./HappiestWorkplacesForYouButton"

const DesktopHappiestWorkplacesForYouDiv = () => {
  return (
    <DesktopBoxWrapper>
      <Text>Find jobs in the World's Happiest Workplaces. Click an organisation's name to explore.</Text>
      <HappiestWorkplacesForYouButton />
      <PlaceholderDiv />
    </DesktopBoxWrapper>
  )
}

export default DesktopHappiestWorkplacesForYouDiv
